import { useState } from 'react';
import { Trans, useLingui } from '@lingui/react/macro';

import config from '@/config';
import Button from '@/design_system/Button';
import Checkbox from '@/design_system/Checkbox';
import Dialog from '@/design_system/Dialog';
import { Footer, FooterButtons } from '@/design_system/Footer';
import Stack from '@/design_system/Stack';
import Paragraph from '@/design_system/Typography/Paragraph';
import IconPrint from '@/icons/Print.svg';
import { ShipmentWithRelations } from '@/models/shipment';

export const ShipmentValidationDialog = ({
  isOpen,
  onOpenChange,
  onValidate,
  shipment,
  isPending,
}: {
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
  onValidate: () => void;
  shipment: ShipmentWithRelations;
  isPending: boolean;
}) => {
  const { t } = useLingui();

  const [validationChecked, setValidationChecked] = useState(false);

  return (
    <Dialog
      title={t({
        id: 'shipment.validate-preparation-dialog.title',
        message: 'Validate preparation',
      })}
      isOpen={isOpen}
      onOpenChange={(value) => {
        setValidationChecked(false);
        onOpenChange(value);
      }}
      style={{ width: '32rem' }}
    >
      <main>
        <Stack gap="1rem">
          <Paragraph>
            <Trans id="shipment.validate-preparation-dialog.message">
              Please confirm that you have printed all items tracking sheets and added them to the
              package. If not, click on the print button.
            </Trans>
          </Paragraph>
          <Checkbox isSelected={validationChecked} onChange={setValidationChecked}>
            <Trans id="shipment.validate-preparation-dialog.validation-checkbox">
              I've already printed all items tracking sheets
            </Trans>
          </Checkbox>
        </Stack>
      </main>
      <Footer>
        <FooterButtons>
          <Button
            variant="secondary"
            size="medium"
            download
            ariaLabel={t({
              id: 'shipment.validate-preparation-dialog.print-items-sheets',
              message: 'Print items tracking sheets',
            })}
            href={`${config.apiUrl}/shipments/${shipment.id}/media?itemsSheets=1`}
          >
            <IconPrint />
            <Trans id="shipment.validate-preparation-dialog.print-items-sheets">
              Print items tracking sheets
            </Trans>
          </Button>
          <Button
            variant="primary"
            size="medium"
            onPress={onValidate}
            disabled={!validationChecked}
            isLoading={isPending}
          >
            <Trans id="shipment.validate-preparation-dialog.validate">Validate</Trans>
          </Button>
        </FooterButtons>
      </Footer>
    </Dialog>
  );
};
